<app-leveltwo [pageName]="'General Info'">
    <div heading="General Info" class="General">
    <br>
      <h3>{{'FactorsPropValue.SearchTitle'|translate}}</h3><br>
      <h4>{{'FactorsPropValue.Locationlocation'|translate}}</h4>
      <p>{{'FactorsPropValue.Thelocation'|translate}}</p>
      <p>{{'FactorsPropValue.Locationalso'|translate}}</p>
      <h4>{{'FactorsPropValue.Upgrades'|translate}}</h4>
      <p>{{'FactorsPropValue.Updatingkitchens'|translate}}</p>
      <h4>{{'FactorsPropValue.Size'|translate}}</h4>
      <p>{{'FactorsPropValue.Whenitcomes'|translate}}</p>
      <h4>{{'FactorsPropValue.Caretakers'|translate}}</h4>
      <p>{{'FactorsPropValue.Beinga'|translate}}</p>
      <h4>{{'FactorsPropValue.Otherfactors'|translate}}</h4>
      <p>{{'FactorsPropValue.Thereare'|translate}}</p>
      <p>{{'FactorsPropValue.Mortage'|translate}}</p>
      <p>{{'FactorsPropValue.Local'|translate}}</p>
      <p>{{'FactorsPropValue.Proximity'|translate}}</p>
      <p>{{'FactorsPropValue.Realestate'|translate}}</p>
      <!--
      <p>{{'FactorsPropValue.Forgeneral'|translate}} <a routerLink="">assessor.lacounty.gov</a> {{'FactorsPropValue.or'|translate}} (888) 807-2111.</p>
      -->

    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
